import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  MapPin,
  History,
  LogOut,
} from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/products', label: 'Products & Suppliers', icon: Package },
  { to: '/admin/locations', label: 'Locations & Users', icon: MapPin },
  { to: '/admin/history', label: 'Order History', icon: History },
];

// Super-admin shell: left sidebar navigation + top bar with wordmark.
export function AdminLayout({ children }: { children: React.ReactNode }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <div className="flex min-h-screen">
      <aside className="hidden w-64 shrink-0 border-r border-line bg-surface md:block">
        <div className="flex h-16 items-center border-b border-line px-6">
          <img src="/lucilles-logo.svg" alt="Lucille's" className="h-10 w-auto" />
        </div>
        <nav className="space-y-1 p-4">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-card px-3 py-2.5 text-sm font-medium transition-colors',
                  isActive ? 'bg-brand/15 text-brand' : 'text-muted hover:bg-surface-2 hover:text-ink',
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-16 items-center justify-between border-b border-line px-6">
          <div className="font-head text-sm font-extrabold uppercase tracking-[0.14em] text-brand">Admin</div>
          <button onClick={handleLogout} className="flex items-center gap-2 rounded p-2 text-muted hover:bg-surface-2 hover:text-ink">
            <LogOut className="h-4 w-4" />
            <span className="text-sm">Sign out</span>
          </button>
        </header>
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  );
}
